import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { StyledEngineProvider } from '@mui/material';

import { commitHash } from '@paragon/client-tools';
import { attemptAutomaticLogInWithStoredToken, initializeDataConnectionsAndLoginTools } from '@paragon/login-tools';
import { ParagonThemeProvider } from '@paragon/themes';

import { Root } from './components/Root';
import { store } from './store';
import { darkTheme, lightTheme } from './themes';

if (commitHash != null) console.log(`Commit hash: ${commitHash}`);

initializeDataConnectionsAndLoginTools(store);

store.dispatch(attemptAutomaticLogInWithStoredToken());

const root = createRoot(document.querySelector('#root')!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ParagonThemeProvider darkTheme={darkTheme} lightTheme={lightTheme}>
          <Root />
        </ParagonThemeProvider>
      </StyledEngineProvider>
    </Provider>
  </React.StrictMode>,
);
